module.exports = __webpack_public_path__ + "static/media/may 2022.34b56af3.svg";